export default "__VITE_ASSET__BjSU3_ft__"